import { useMutation } from '@tanstack/react-query';
import { toast } from 'sonner';

import Axios from '@/lib/axios-instance';

type APIPayload = {
  url: string;
};

// Define the response type based on the expected structure
export type CrawlResponse = {
  meta: {
    error: boolean;
    code: number;
    message: string;
  };
  data: {
    crawl_id: string;
  };
};

export const addSourceWebsite = async (payload: APIPayload): Promise<CrawlResponse> => {
  try {
    const response = await Axios.get(
      `/files/crawl_website_with_progress?base_url=${payload.url}`,
    );
    return response.data as CrawlResponse;
  } catch (error: any) {
    if (error.response) {
      throw new Error(
        `${error.response.data?.meta?.message || 'An error occurred'}`,
      );
    }
    throw new Error(error.message || 'Network Error');
  }
};

export const useAddSourceWebsite = () => {
  return useMutation<CrawlResponse, Error, APIPayload>({
    mutationFn: (payload: APIPayload) => addSourceWebsite(payload),
    onSuccess: (data) => {
      toast.success('Source URL Added Successfully');
      console.log(data);
    },
    onError: (error) => {
      toast.error('Adding Source URL Failed', { description: error.message });
    },
  });
};
